/**
 * Created by prog2 on 25/10/2018.
 */

export default {
    message: {
        title: 'KATHEDRAAL VAN VALENCIA',
        preferVisitRead: 'Prefereixo llegir',
        preferVisitListten: 'Prefereixo escoltar ',
        downloadAudio: '(Downloading)',
        download:'Downloading',
        errorDownload: '',
        cancelDownload: '',
        initDownload: 'Even geduld a.u.b.',
        endDownload: 'Audiotracks gedownload. Geniet van uw bezoek!',
        retry: 'Reintentar',
        noConnection: '',
        titleMap: '',
        map: 'Plano1.png',
        menuItems: [
            {
                idImages: 1,
                title: 'Welkom',
                author: 'Gebruik een hoofdtelefoon',
                description: '',
                // audio: require('./../../assets/audio/ESP/1.mp3')
                audio: '1.mp3'
            },
            {
                idImages: 2,
                title: 'Kapel van Sint-Sebastiaan',
                author: 'Voet van het schip ',
                description: '',
                audio: '2.mp3'

            },
            {
                idImages: 3,
                title: 'Kapel van de heilige Petrus ',
                author: 'Rechter zijbeuk',
                description: '',
                audio: '3.mp3'

            },
            {
                idImages: 4,
                title: 'Kapel van Sint Franciscus Borgia',
                author: 'Rechter zijbeuk',
                description: '',
                audio: '4.mp3'

            },
            {
                idImages: 5,
                title: 'Het schuin ingezette venster',
                author: '',
                description: '.',
                audio: '5.mp3'

            },
            {
                idImages: 6,
                title: 'Hoofdaltaar',
                author: 'Hoofdkapel',
                description: '',
                audio: '6.mp3'

            },
            {
                idImages: 7,
                title: 'Muzikantengelen',
                author: 'Hoofdkapel',
                description: '',
                audio: '7.mp3'

            },
            {
                idImages: 8,
                title: 'Koepelgewelf',
                author: 'Dwarsschip',
                description: '',
                audio: '8.mp3'

            },
            {
                idImages: 9,
                title: 'Aalmoezenportaal',
                author: 'Rechterarm van het dwarsschip ',
                description: '',
                audio: '9.mp3'

            },
            {
                idImages: 10,
                title: 'Kooromgang + Orgel',
                author: 'Kooromgang',
                description: '',
                audio: '10.mp3'

            },
            {
                idImages: 11,
                title: 'Verrijzeniskapel ',
                author: 'Kapellen van de kooromgang',
                description: '',
                audio: '11.mp3'

            },
            {
                idImages: 12,
                title: 'Christus van de Goede Dood',
                author: 'Kapellen van de kooromgang',
                description: '',
                audio: '12.mp3'

            },
            {
                idImages: 13,
                title: 'Madonna met de stoel ',
                author: 'Kapellen van de kooromgang',
                description: '',
                audio: '13.mp3'

            },
            {
                idImages: 14,
                title: 'St. Dionysius en St. Margareta',
                author: 'Kapellen van de kooromgang',
                description: '',
                audio: '14.mp3'

            },
            {
                idImages: 15,
                title: 'Portaal van de Apostelen ',
                author: 'Linkerarm van het dwarsschip',
                description: '',
                audio: '15.mp3'

            },
            {
                idImages: 16,
                title: 'Vervolg van het bezoek',
                author: 'Linker zijbeuk',
                description: '',
                audio: '16.mp3'

            },
            {
                idImages: 17,
                title: 'Monstrans',
                author: 'Museum: begane grond',
                description: '',
                audio: '17.mp3'

            },
            {
                idImages: 18,
                title: 'Slechte moordenaar + Aanbidding ',
                author: 'Museum: begane grond',
                description: '',
                audio: '18.mp3'

            },
            {
                idImages: 19,
                title: 'Maquettes ',
                author: 'Museum: tweede verdieping',
                description: '',
                audio: '19.mp3'

            },
            {
                idImages: 20,
                title: 'Apostelen',
                author: 'Museum: tweede verdieping',
                description: '',
                audio: '20.mp3'

            },
            {
                idImages: 21,
                title: 'Sint-Thomas + Ontslapenis ',
                author: 'Museum: tweede verdieping',
                description: '',
                audio: '21.mp3'

            },
            {
                idImages: 22,
                title: 'Reliekschrijn',
                author: 'Museum: tweede verdieping',
                description: '',
                audio: '22.mp3'

            },
            {
                idImages: 23,
                title: 'Improperiën ',
                author: 'Museum: tweede verdieping',
                description: '',
                audio: '23.mp3'

            },
            {
                idImages: 24,
                title: 'Gang + Barokke kunst',
                author: 'Museum: tweede verdieping',
                description: '',
                audio: '24.mp3'

            },
            {
                idImages: 25,
                title: 'Archeologische vindplaats',
                author: 'Museum: benedenverdieping',
                description: '',
                audio: '25.mp3'

            },
            {
                idImages: 26,
                title: 'Koorboeken + Laatste Avondmaal',
                author: 'Museum: begane grond',
                description: '',
                audio: '26.mp3'

            },
            {
                idImages: 27,
                title: 'De Heilige Kelk ',
                author: 'Kapel van de Heilige Kelk',
                description: '',
                audio: '27.mp3'

            },
            {
                idImages: 28,
                title: 'Kapel van de Heilige Kelk',
                author: 'Kapel van de Heilige Kelk',
                description: '',
                audio: '28.mp3'

            },
            {
                idImages: 29,
                title: 'El Micalet',
                author: 'Voet van het schip ',
                description: '',
                audio: '29.mp3'

            },
            {
                idImages: 30,
                title: 'Credits',
                isCredits:true,
                author: '',
                description: 'Trama Media voor de Kathedraal van Valencia.<br><br>© Kathedraal van Valencia.<br><br>Alle rechten voorbehouden.<br><br>',
                audio: '',
                idCreditImage: 30,
            },


        ]

    }
};



// WEBPACK FOOTER //
// ./src/data/i18n/holandes.js